const initialState = {
    get: [], 
    
    
  
  };
  
  const MOActivitiesReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_ACTGET_SUCCESS':
            return {... state, get:action.payload};
            
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default MOActivitiesReducers;
  
  